function userLocation() {

    var button   = $('._js-user-location-button'),
        location = $('._js-user-location-link'),
        value    = $('._js-chosen-city');

    button.on('click', function(){

        var parent = $(this).parents('.user-location');

        if ( !parent.hasClass('_active') ) {
            parent.addClass('_active');
        } else {
            parent.removeClass('_active');
        }
    });
    location.on('click', function(){
        var city = $(this).text(),
            parent = $(this).parents('.user-location');

        if ( city != value.text() ) {
            location.removeClass('_selected');
            $(this).addClass('_selected');

            value.text(city);
            parent.removeClass('_active');
        }
    });

    $(document).on('mouseup touchend', function(e){
        if (!$('.user-location').is(e.target) && $('.user-location').has(e.target).length === 0) {
            $('.user-location').removeClass('_active');
        }
    });

}